import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useCertStore = defineStore('useCertStore', () => {
  const _cert = ref(true);

  const isCertInstalled = computed(() => _cert.value);

  function setIsCertInstalled(value: boolean): void {
    _cert.value = value;
  }

  return {
    isCertInstalled,
    setIsCertInstalled,
  };
});
